import { Outlet } from "react-router";
import { AxiosError } from "axios";
import { OrgProvider } from "../../org/providers";
import { WorkspaceScreen } from "../../workspace/components/WorkspaceScreen";
import { UnauthorizedMessage } from "../../shared/components";
import { useUserManagementPermissions, useListUsersInMyOrgs } from "../hooks";

export function UserManagementLayout() {
  const { canView } = useUserManagementPermissions();
  const usersQuery = useListUsersInMyOrgs();

  // Check if the probe query returned a 403
  const is403 =
    usersQuery.error instanceof AxiosError &&
    usersQuery.error.response?.status === 403;

  const isAccessDenied = is403 || (!canView && !usersQuery.isLoading);

  if (isAccessDenied) {
    return (
      <WorkspaceScreen>
        <UnauthorizedMessage />
      </WorkspaceScreen>
    );
  }

  // Show generic error for non-403 failures (network errors, 5xx, timeouts, etc.)
  if (usersQuery.error && !usersQuery.isLoading) {
    return (
      <WorkspaceScreen>
        <p>Something went wrong loading user data. Please try again later.</p>
      </WorkspaceScreen>
    );
  }

  // Wait for the probe query to succeed before rendering child routes,
  // so they don't fire their own requests that would also 403.
  if (usersQuery.isLoading) {
    return <WorkspaceScreen wide />;
  }

  return (
    <WorkspaceScreen wide>
      <OrgProvider>
        <Outlet />
      </OrgProvider>
    </WorkspaceScreen>
  );
}
